const images = {
  COMING_SOON: require("../assets/images/coming-soon-image.jpg"),
  PEXELS_ALEKSANDRA_PLATONOVA: require("../assets/images/pexels-aleksandra-platonova-2263510-2.jpg"),
  ERROR: require("../assets/images/404-error.jpg"),
  IMAGE_UNAVAILABLE: require("../assets/images/no-image-available.png"),
  ABOUT_US: require("../assets/images/work01.jpg"),
  LOGO: require("../assets/images/TWI logo_white.png"),
  TWI_ASSETS_THREE: require("../assets/images/twi assets-03.png"),
  TWI_ASSETS_TWO: require("../assets/images/twi assets-02.png"),
  TWI_ASSETS_FOUR: require("../assets/images/twi assets-04.png"),
  TWI_ASSETS_FIVE: require("../assets/images/twi assets-05.png"),
  TWI_ASSETS_SIX: require("../assets/images/twi assets-06.png"),
  BANNER_IMAGE: require("../assets/images/carousel3.jpg"),
  TWI_CAROUSEL_ONE: require("../assets/images/TWI CAROUSEL 01.jpg"),
  TWI_CAROUSEL_TWO: require("../assets/images/TWI CAROUSEL 02.jpg"),
  TWI_CAROUSEL_THREE: require("../assets/images/TWI CAROUSEL 03.jpg"),
  TWI_CAROUSEL_FOUR: require("../assets/images/TWI CAROUSEL 04.jpg"),
  CLIENT_LOGO_ITC: require("../assets/images/ITC.png"),
  TEC_WORKSHOP_LOGO_WORDMARK_WHITE: require("../assets/images/TWI-wordmark-white.png"),
  TEC_WORKSHOP_LOGO_WORDMARK_BLUE: require("../assets/images/TWI-wordmark-blue.png"),
  OUR_PLANT: require("../assets/images/Plant-photo.png"),
  ABOUT_INTRO: require("../assets/images/About-Page.jpg"),
};

export default images;
